// import Events from 'components/pages/user/profile/Events';
import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Modal, Row } from 'react-bootstrap';
// import { Link } from 'react-router-dom';
// import events from 'data/events/events';
import PropTypes from 'prop-types';
import IconButton from 'components/common/IconButton';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { getReasonAll } from 'nursd-dashboard/api/reason';
import { useAuth } from 'nursd-dashboard/context/AuthContext';
import UploadFile from 'nursd-dashboard/nurse/user/profile/table/UploadFile';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { updateJobTable } from 'nursd-dashboard/api/jobTable';
import { socket } from 'nursd-dashboard/api/socket';
import { getNurseUniqueIdDetails } from 'nursd-dashboard/api/nurseTable';
import { postNurseNotification } from 'nursd-dashboard/api/nurseNotification';
import { sendNotification } from 'nursd-dashboard/api/webNotification';
import { getFacilityDetails } from 'nursd-dashboard/api/facilityTable';
import { postFacilityNotification } from 'nursd-dashboard/api/facilityNotification';
import { uploadFile } from 'nursd-dashboard/utils/AWSHelper';
import {
  getFileAsUint8Array,
  jobUniqueId,
  jobUniqueIdDoc,
  timeDifferent,
  totalAmount
} from 'nursd-dashboard/utils/function';
import { useAppContext } from 'providers/AppProvider';

const JobDetailAside = ({ job, getJobDetail }) => {
  const {
    config: { isDark }
  } = useAppContext();

  const { authToken } = useAuth();
  const animatedComponents = makeAnimated();

  const [docViewModel, setDocViewModel] = useState({
    view: false,
    name: '',
    url: ''
  });
  const [comments, setComments] = useState('');
  const [completeJob, setCompleteJob] = useState(false);
  const [loading, setLoading] = useState(undefined);
  const [valueReason, setValueReason] = useState(undefined);
  const [missedReason, setMissedReason] = useState(undefined);
  const [formData, setFormData] = useState({
    reason: '',
    pendingOrNoShowFacilityDecideMessage: ''
  });
  const [fileDoc, setFileDoc] = useState([]);
  const [jobClockDetails, setJobClockDetails] = useState({
    checkInTimeNurse: new Date(),
    checkInFullAddressNurse: '',
    checkInLatitudeNurse: '',
    checkInLongitudeNurse: '',
    checkOutTimeNurse: new Date(),
    checkOutFullAddressNurse: '',
    checkOutLatitudeNurse: '',
    checkOutLongitudeNurse: ''
  });

  const handleRemoveDoc = path => {
    setFileDoc(fileDoc.filter(file => file.path !== path));
  };

  const getReasons = async authToken => {
    try {
      const data = await getReasonAll(authToken);
      // console.log(data);
      let array = [];
      //Job
      for (let i = 0; i < data[0]?.facilityReasons?.length; i++) {
        const item = data[0]?.facilityReasons[i];
        let obj = {
          reason: item?.reason,
          reasonCode: item?.reasonCode,
          label: item?.reason,
          value: i + 1
        };
        array.push(obj);
      }
      if (data[0]?.facilityReasons?.length === array?.length) {
        setMissedReason(array);
      }
    } catch (error) {
      console.log('data save error:', error);
    }
  };

  useEffect(() => {
    if (job !== undefined) {
      setJobClockDetails({
        ...jobClockDetails,
        checkInTimeNurse:
          job?.checkInTime !== ''
            ? new Date(job?.checkInTimeNurse)
            : new Date(job?.startTime),
        checkOutTimeNurse:
          job?.checkOutTime !== ''
            ? new Date(job?.checkOutTimeNurse)
            : new Date(job?.endTime)
      });
    }
  }, [job]);

  useEffect(() => {
    if (authToken) {
      getReasons(authToken);
    }
  }, []);

  const handleChange = ({ target }) => {
    let name = target.name;
    let value = target.value;
    setFormData({ ...formData, [name]: value });
  };

  const getFacilityDetail = async id => {
    // console.log(id);
    try {
      const facilityData = await getFacilityDetails(authToken, id);
      return facilityData;
    } catch (error) {
      console.log('data save error:', error);
    }
  };

  // Example usage: After a file is dropped, convert it to Uint8Array
  const handleConvert = async file => {
    if (file && file[0]) {
      const uint8Array = await getFileAsUint8Array(file[0]);
      return uint8Array; // Do something with the Uint8Array
    }
  };

  const pendingOrNoShowFacilityDecide = async data => {
    setLoading(true);
    if (formData?.reason === '') {
      alert('Please select the reason...');
      setLoading(false);
    } else if (formData?.pendingOrNoShowFacilityDecideMessage === '') {
      alert('Please fill the message...');
      setLoading(false);
    } else {
      let enterTime =
        moment(new Date(job?.checkInTimeNurse)).format('hh:mm a') ===
        moment(new Date(jobClockDetails?.checkInTimeNurse)).format('hh:mm a')
          ? job?.checkInTimeNurse
          : jobClockDetails?.checkInTimeNurse;

      let exitTime =
        moment(new Date(job?.checkOutTimeNurse)).format('hh:mm a') ===
        moment(new Date(jobClockDetails?.checkOutTimeNurse)).format('hh:mm a')
          ? job?.checkOutTimeNurse
          : jobClockDetails?.checkOutTimeNurse;

      let adjustStart =
        moment(new Date(job?.checkInTimeNurse)).format('hh:mm a') ===
        moment(new Date(jobClockDetails?.checkInTimeNurse)).format('hh:mm a')
          ? false
          : true;
      let adjustEnd =
        moment(new Date(job?.checkOutTimeNurse)).format('hh:mm a') ===
        moment(new Date(jobClockDetails?.checkOutTimeNurse)).format('hh:mm a')
          ? false
          : true;

      let adjust = adjustStart === true || adjustEnd === true ? true : false;

      if (fileDoc.length === 0) {
        await updateJobTable(authToken, job?.id, {
          jobStatus: 'Completed',
          worked_hours: timeDifferent(enterTime, exitTime),
          total_payment: totalAmount(enterTime, exitTime, data?.baseRate),
          checkInTime: new Date(enterTime)?.toString(),
          checkInFullAddress: job?.fullAddress,
          checkInLatitude: job?.latitude.toString(),
          checkInLongitude: job?.longitude.toString(),
          checkOutTime: new Date(exitTime)?.toString(),
          checkOutFullAddress: job?.fullAddress,
          checkOutLatitude: job?.latitude.toString(),
          checkOutLongitude: job?.longitude.toString(),
          checkOutMessage: 'Facility Approved',
          approved_manager: job?.jobPostingTableFacilityTableId,
          closed_by: job?.jobPostingTableFacilityTableId,
          timeAdjustByFacility: adjust,
          pendingOrNoShowFacilityDecideMessage:
            formData?.pendingOrNoShowFacilityDecideMessage,
          pendingOrNoShowFacilityDecideStatus: true,
          noShowManagerReason: formData?.reason
        })
          .then(async () => {
            socket?.emit('tableJobInsert', {
              table: 'JobPostingTable',
              message: 'Fetch Dashboard Job'
            });
            const nurse = await getNurseUniqueIdDetails(
              authToken,
              job?.jobFinalSelectionNurseId
            );

            let nurseData = nurse[0];

            if (nurseData) {
              if (nurseData?.mobileId) {
                sendNotification(authToken, {
                  expoPushToken: nurseData?.mobileId,
                  title: job?.shiftTitle,
                  body:
                    `Job ${jobUniqueId(job?.id, job?.jobType)}` +
                    '-' +
                    ` Missed ${job?.jobType} Job is Approved`,
                  data: { jobId: job?.id, screen: 'JobDetailScreen' }
                });
                await postNurseNotification(
                  authToken,
                  nurseData?.id,
                  '',
                  jobUniqueId(job?.id, job?.jobType),
                  ` Missed ${job?.jobType} Job is Approved`,
                  'JobDetailsScreen',
                  {
                    id: job?.id
                  },
                  false,
                  false,
                  'green',
                  ''
                );
                socket?.emit('tableNotificationInsert', {
                  table: 'NurseNotificationTable',
                  id: nurseData?.id
                });
              }
              setLoading(false);
              setFileDoc([]);
              setJobClockDetails({
                checkInTimeNurse: '',
                checkOutTimeNurse: '',
                checkInFullAddressNurse: '',
                checkInLatitudeNurse: '',
                checkInLongitudeNurse: '',
                checkOutFullAddressNurse: '',
                checkOutLatitudeNurse: '',
                checkOutLongitudeNurse: ''
              });
            }

            if (
              parseInt(job?.jobPostingTableFacilityTableId) !==
              parseInt(job?.jobPostingTableFacilityTableId)
            ) {
              const facilityDetail = await getFacilityDetail(
                job?.jobPostingTableFacilityTableId
              );

              await postFacilityNotification(
                authToken,
                job?.manager?.id,
                '',
                jobUniqueId(job?.id, job?.jobType),
                `Your Missed ${job?.jobType} Job is Reviewed and Approved by ${facilityDetail?.firstName} ${facilityDetail?.lastName}.`,
                'JobDetailsScreen',
                {
                  id: job?.id
                },
                false,
                false,
                'green',
                ''
              );
              socket?.emit('tableNotificationInsert', {
                table: 'FacilityNotificationTable',
                id: job?.manager?.id
              });

              if (job?.manager?.mobileId) {
                sendNotification(authToken, {
                  expoPushToken: job?.manager?.mobileId,
                  title: jobUniqueId(job?.id, job?.jobType),
                  body: `Your Missed ${job?.jobType} Job is Reviewed and Approved by ${facilityDetail?.firstName} ${facilityDetail?.lastName}.`,
                  data: { jobId: job?.id, screen: 'JobDetailScreen' }
                });
              }
            }
            alert('Approved successfully.');
            getJobDetail(job?.id);
          })
          .catch(e => console.log(e));
      } else {
        const buffer = await handleConvert(fileDoc);
        let name = `noShow/${`noShowManager-${jobUniqueIdDoc(
          job?.createdAt,
          job?.jobType
        )}`}.pdf`;
        await uploadFile(
          authToken,
          name,
          buffer,
          'File upload successfully.'
        ).then(async res => {
          if (res && res?.Key) {
            await updateJobTable(authToken, job?.id, {
              jobStatus: 'Completed',
              worked_hours: timeDifferent(enterTime, exitTime),
              total_payment: totalAmount(enterTime, exitTime, data?.baseRate),
              checkInTime: new Date(enterTime)?.toString(),
              checkInFullAddress: job?.fullAddress,
              checkInLatitude: job?.latitude.toString(),
              checkInLongitude: job?.longitude.toString(),
              checkOutTime: new Date(exitTime)?.toString(),
              checkOutFullAddress: job?.fullAddress,
              checkOutLatitude: job?.latitude.toString(),
              checkOutLongitude: job?.longitude.toString(),
              checkOutMessage: 'Facility Approved',
              approved_manager: job?.jobPostingTableFacilityTableId,
              closed_by: job?.jobPostingTableFacilityTableId,
              timeAdjustByFacility: adjust,
              pendingOrNoShowFacilityDecideMessage:
                formData?.pendingOrNoShowFacilityDecideMessage,
              pendingOrNoShowFacilityDecideStatus: true,
              noShowManagerReason: formData?.reason,
              noShowManagerReasonAttachment: res?.Key
            })
              .then(async () => {
                socket?.emit('tableJobInsert', {
                  table: 'JobPostingTable',
                  message: 'Fetch Dashboard Job'
                });
                const nurse = await getNurseUniqueIdDetails(
                  authToken,
                  job?.jobFinalSelectionNurseId
                );

                let nurseData = nurse[0];
                if (nurseData) {
                  if (nurseData.mobileId) {
                    sendNotification(authToken, {
                      expoPushToken: nurseData.mobileId,
                      title: job?.shiftTitle,
                      body:
                        `Job ${jobUniqueId(job?.id, job?.jobType)}` +
                        '-' +
                        ` Missed ${job?.jobType} Job is Approved`,
                      data: { jobId: job?.id, screen: 'JobDetailScreen' }
                    });
                  }
                  await postNurseNotification(
                    authToken,
                    nurseData?.id,
                    '',
                    jobUniqueId(job?.id, job?.jobType),
                    ` Missed ${job?.jobType} Job is Approved`,
                    'JobDetailsScreen',
                    {
                      id: job?.id
                    },
                    false,
                    false,
                    'green',
                    ''
                  );
                  socket?.emit('tableNotificationInsert', {
                    table: 'NurseNotificationTable',
                    id: nurseData?.id
                  });
                  setLoading(false);
                  setFileDoc([]);
                  setJobClockDetails({
                    checkInTimeNurse: '',
                    checkOutTimeNurse: '',
                    checkInFullAddressNurse: '',
                    checkInLatitudeNurse: '',
                    checkInLongitudeNurse: '',
                    checkOutFullAddressNurse: '',
                    checkOutLatitudeNurse: '',
                    checkOutLongitudeNurse: ''
                  });
                }

                if (
                  parseInt(job?.jobPostingTableFacilityTableId) !==
                  parseInt(job?.jobPostingTableFacilityTableId)
                ) {
                  const facilityDetail = await getFacilityDetail(
                    job?.jobPostingTableFacilityTableId
                  );

                  await postFacilityNotification(
                    authToken,
                    job?.manager?.id,
                    '',
                    jobUniqueId(job?.id, job?.jobType),
                    `Your Missed ${job?.jobType} Job is Reviewed and Approved by ${facilityDetail?.firstName} ${facilityDetail?.lastName}.`,
                    'JobDetailsScreen',
                    {
                      id: job?.id
                    },
                    false,
                    false,
                    'green',
                    ''
                  );
                  socket?.emit('tableNotificationInsert', {
                    table: 'FacilityNotificationTable',
                    id: job?.manager?.id
                  });

                  if (job?.manager?.mobileId) {
                    sendNotification(authToken, {
                      expoPushToken: job?.manager?.mobileId,
                      title: jobUniqueId(job?.id, job?.jobType),
                      body: `Your Missed ${job?.jobType} Job is Reviewed and Approved by ${facilityDetail?.firstName} ${facilityDetail?.lastName}.`,
                      data: { jobId: job?.id, screen: 'JobDetailScreen' }
                    });
                  }
                }
                alert('Approved successfully.');
                getJobDetail(job?.id);
              })
              .catch(e => console.log(e));
          }
        });
      }
    }
  };

  const pendingOrNoShowFacilityDecideCancel = async () => {
    setLoading(true);
    if (formData?.reason === '') {
      alert('Please select the reason...');
      setLoading(false);
    } else if (formData?.pendingOrNoShowFacilityDecideMessage === '') {
      alert('Please fill the message...');
      setLoading(false);
    } else {
      if (fileDoc.length === 0) {
        await updateJobTable(authToken, job?.id, {
          worked_hours: '0',
          total_payment: '0',
          pendingOrNoShowFacilityDecideMessage:
            formData?.pendingOrNoShowFacilityDecideMessage,
          pendingOrNoShowFacilityDecideStatus: false,
          noShowManagerReason: formData?.reason,
          approved_manager: job?.jobPostingTableFacilityTableId,
          closed_by: job?.jobPostingTableFacilityTableId
        })
          .then(async () => {
            socket?.emit('tableJobInsert', {
              table: 'JobPostingTable',
              message: 'Fetch Dashboard Job'
            });
            const nurse = await getNurseUniqueIdDetails(
              authToken,
              job?.jobFinalSelectionNurseId
            );

            let nurseData = nurse[0];

            if (nurseData) {
              if (nurseData.mobileId) {
                sendNotification(authToken, {
                  expoPushToken: nurseData.mobileId,
                  title: job?.shiftTitle,
                  body:
                    `Job ${jobUniqueId(job?.id, job?.jobType)}` +
                    '-' +
                    ` Missed ${job?.jobType} Job is Not Approved`,
                  data: { jobId: job?.id, screen: 'JobDetailScreen' }
                });
              }
              await postNurseNotification(
                authToken,
                nurseData?.id,
                '',
                jobUniqueId(job?.id, job?.jobType),
                ` Missed ${job?.jobType} Job is Not Approved`,
                'JobDetailsScreen',
                {
                  id: job?.id
                },
                false,
                false,
                'red',
                ''
              );
              socket?.emit('tableNotificationInsert', {
                table: 'NurseNotificationTable',
                id: nurseData?.id
              });
              setLoading(false);
              setFileDoc([]);
              setJobClockDetails({
                checkInTimeNurse: '',
                checkOutTimeNurse: '',
                checkInFullAddressNurse: '',
                checkInLatitudeNurse: '',
                checkInLongitudeNurse: '',
                checkOutFullAddressNurse: '',
                checkOutLatitudeNurse: '',
                checkOutLongitudeNurse: ''
              });
            }

            if (
              parseInt(job?.jobPostingTableFacilityTableId) !==
              parseInt(job?.jobPostingTableFacilityTableId)
            ) {
              const facilityDetail = await getFacilityDetail(
                job?.jobPostingTableFacilityTableId
              );

              await postFacilityNotification(
                authToken,
                job?.manager?.id,
                '',
                jobUniqueId(job?.id, job?.jobType),
                `Your Missed ${job?.jobType} Job is Reviewed and Not Approved by ${facilityDetail?.firstName} ${facilityDetail?.lastName}.`,
                'JobDetailsScreen',
                {
                  id: job?.id
                },
                false,
                false,
                'green',
                ''
              );
              socket?.emit('tableNotificationInsert', {
                table: 'FacilityNotificationTable',
                id: job?.manager?.id
              });

              if (job?.manager?.mobileId) {
                sendNotification(authToken, {
                  expoPushToken: job?.manager?.mobileId,
                  title: jobUniqueId(job?.id, job?.jobType),
                  body: `Your Missed ${job?.jobType} Job is Reviewed and Not Approved by ${facilityDetail?.firstName} ${facilityDetail?.lastName}.`,
                  data: { jobId: job?.id, screen: 'JobDetailScreen' }
                });
              }
            }
            alert('Not-Approved successfully.');
            getJobDetail(job?.id);
          })
          .catch(e => console.log(e));
      } else {
        const buffer = await handleConvert(fileDoc);
        let name = `noShow/${`noShowManager-${jobUniqueIdDoc(
          job?.createdAt,
          job?.jobType
        )}`}.pdf`;
        await uploadFile(
          authToken,
          name,
          buffer,
          'File upload successfully.'
        ).then(async res => {
          if (res && res?.Key) {
            await updateJobTable(authToken, job?.id, {
              worked_hours: '0',
              total_payment: '0',
              pendingOrNoShowFacilityDecideMessage:
                formData?.pendingOrNoShowFacilityDecideMessage,
              pendingOrNoShowFacilityDecideStatus: false,
              noShowManagerReason: formData?.reason,
              noShowManagerReasonAttachment: res?.Key,
              approved_manager: job?.jobPostingTableFacilityTableId,
              closed_by: job?.jobPostingTableFacilityTableId
            })
              .then(async () => {
                socket?.emit('tableJobInsert', {
                  table: 'JobPostingTable',
                  message: 'Fetch Dashboard Job'
                });
                const nurse = await getNurseUniqueIdDetails(
                  authToken,
                  job?.jobFinalSelectionNurseId
                );

                let nurseData = nurse[0];

                if (nurseData) {
                  if (nurseData?.mobileId) {
                    sendNotification(authToken, {
                      expoPushToken: nurseData.mobileId,
                      title: job?.shiftTitle,
                      body:
                        `Job ${jobUniqueId(job?.id, job?.jobType)}` +
                        '-' +
                        ` Missed ${job?.jobType} Job is Not Approved`,
                      data: { jobId: job?.id, screen: 'JobDetailScreen' }
                    });
                  }
                  await postNurseNotification(
                    authToken,
                    nurseData?.id,
                    '',
                    jobUniqueId(job?.id, job?.jobType),
                    ` Missed ${job?.jobType} Job is Not Approved`,
                    'JobDetailsScreen',
                    {
                      id: job?.id
                    },
                    false,
                    false,
                    'red',
                    ''
                  );
                  socket?.emit('tableNotificationInsert', {
                    table: 'NurseNotificationTable',
                    id: nurseData?.id
                  });
                }
                setLoading(false);
                setFileDoc([]);
                setJobClockDetails({
                  checkInTimeNurse: '',
                  checkOutTimeNurse: '',
                  checkInFullAddressNurse: '',
                  checkInLatitudeNurse: '',
                  checkInLongitudeNurse: '',
                  checkOutFullAddressNurse: '',
                  checkOutLatitudeNurse: '',
                  checkOutLongitudeNurse: ''
                });

                if (
                  parseInt(job?.jobPostingTableFacilityTableId) !==
                  parseInt(job?.jobPostingTableFacilityTableId)
                ) {
                  const facilityDetail = await getFacilityDetail(
                    job?.jobPostingTableFacilityTableId
                  );

                  await postFacilityNotification(
                    authToken,
                    job?.manager?.id,
                    '',
                    jobUniqueId(job?.id, job?.jobType),
                    `Your Missed ${job?.jobType} Job is Reviewed and Not Approved by ${facilityDetail?.firstName} ${facilityDetail?.lastName}.`,
                    'JobDetailsScreen',
                    {
                      id: job?.id
                    },
                    false,
                    false,
                    'green',
                    ''
                  );
                  socket?.emit('tableNotificationInsert', {
                    table: 'FacilityNotificationTable',
                    id: job?.manager?.id
                  });

                  if (job?.manager?.mobileId) {
                    sendNotification(authToken, {
                      expoPushToken: job?.manager?.mobileId,
                      title: jobUniqueId(job?.id, job?.jobType),
                      body: `Your Missed ${job?.jobType} Job is Reviewed and Not Approved by ${facilityDetail?.firstName} ${facilityDetail?.lastName}.`,
                      data: { jobId: job?.id, screen: 'JobDetailScreen' }
                    });
                  }
                }
                alert('Not-Approved successfully.');
                getJobDetail(job?.id);
              })
              .catch(e => console.log(e));
          }
        });
      }
    }
  };

  const pendingJobOrNoShowFacilityDecide = async () => {
    setLoading(true);
    if (formData?.pendingOrNoShowFacilityDecideMessage === '') {
      alert('Please fill the reason...');
      setLoading(false);
    } else {
      if (fileDoc.length === 0) {
        await updateJobTable(authToken, job?.id, {
          jobStatus: 'Completed',
          worked_hours: timeDifferent(job?.checkInTime, job?.checkOutTimeNurse),
          total_payment: totalAmount(
            job?.checkInTime,
            job?.checkOutTimeNurse,
            job?.baseRate
          ),
          checkOutTime: job?.checkOutTimeNurse,
          checkOutFullAddress: job?.fullAddress,
          checkOutLatitude: job?.latitude.toString(),
          checkOutLongitude: job?.longitude.toString(),
          checkOutMessage: 'Facility Approved',
          approved_manager: job?.jobPostingTableFacilityTableId,
          closed_by: job?.jobPostingTableFacilityTableId,
          timeAdjustByNurse: true,
          pendingOrNoShowFacilityDecideMessage:
            formData?.pendingOrNoShowFacilityDecideMessage,
          pendingOrNoShowFacilityDecideStatus: true,
          neverCheckOutManagerReason: formData?.reason,
          neverCheckOutManagerReasonAttachment: ''
        })
          .then(async () => {
            socket?.emit('tableJobInsert', {
              table: 'JobPostingTable',
              message: 'Fetch Dashboard Job'
            });
            const nurse = await getNurseUniqueIdDetails(
              authToken,
              job?.jobFinalSelectionNurseId
            );

            let nurseData = nurse[0];
            if (nurseData) {
              if (nurseData.mobileId) {
                sendNotification(authToken, {
                  expoPushToken: nurseData.mobileId,
                  title: job?.shiftTitle,
                  body:
                    `Job ${jobUniqueId(job?.id, job?.jobType)}` +
                    '-' +
                    ` Pending Clock Out Job is Approved`,
                  data: { jobId: job?.id, screen: 'JobDetailScreen' }
                });
              }
              await postNurseNotification(
                authToken,
                nurseData?.id,
                '',
                jobUniqueId(job?.id, job?.jobType),
                ` Pending Clock Out Job is Approved`,
                'JobDetailsScreen',
                {
                  id: job?.id
                },
                false,
                false,
                'green',
                ''
              );
              socket?.emit('tableNotificationInsert', {
                table: 'NurseNotificationTable',
                id: nurseData?.id
              });
              setLoading(false);
            }

            if (
              parseInt(job?.jobPostingTableFacilityTableId) !==
              parseInt(job?.jobPostingTableFacilityTableId)
            ) {
              const facilityDetail = await getFacilityDetail(
                job?.jobPostingTableFacilityTableId
              );

              await postFacilityNotification(
                authToken,
                job?.manager?.id,
                '',
                jobUniqueId(job?.id, job?.jobType),
                `Your Pending Clock Out Job Reviewed and Approved by ${facilityDetail?.firstName} ${facilityDetail?.lastName}.`,
                'JobDetailsScreen',
                {
                  id: job?.id
                },
                false,
                false,
                'green',
                ''
              );
              socket?.emit('tableNotificationInsert', {
                table: 'FacilityNotificationTable',
                id: job?.manager?.id
              });
              if (job?.manager?.mobileId) {
                sendNotification(authToken, {
                  expoPushToken: job?.manager?.mobileId,
                  title: jobUniqueId(job?.id, job?.jobType),
                  body: `Your Pending Clock Out Job Reviewed and Approved by ${facilityDetail?.firstName} ${facilityDetail?.lastName}.`,
                  data: { jobId: job?.id, screen: 'JobDetailScreen' }
                });
              }
            }
            alert('Approved successfully.');
            getJobDetail(job?.id);
          })
          .catch(e => console.log(e));
      } else {
        const buffer = await handleConvert(fileDoc);
        let name = `pendingNeverCheckOut/${`pendingNeverCheckOutManager-${jobUniqueIdDoc(
          job?.createdAt,
          job?.jobType
        )}`}.pdf`;
        await uploadFile(authToken, name, buffer, '').then(async res => {
          if (res && res?.Key) {
            await updateJobTable(authToken, job?.id, {
              jobStatus: 'Completed',
              worked_hours: timeDifferent(
                job?.checkInTime,
                job?.checkOutTimeNurse
              ),
              total_payment: totalAmount(
                job?.checkInTime,
                job?.checkOutTimeNurse,
                job?.baseRate
              ),
              checkOutTime: job?.checkOutTimeNurse,
              checkOutFullAddress: job?.fullAddress,
              checkOutLatitude: job?.latitude.toString(),
              checkOutLongitude: job?.longitude.toString(),
              checkOutMessage: 'Facility Approved',
              approved_manager: job?.jobPostingTableFacilityTableId,
              closed_by: job?.jobPostingTableFacilityTableId,
              timeAdjustByNurse: true,
              pendingOrNoShowFacilityDecideMessage:
                formData?.pendingOrNoShowFacilityDecideMessage,
              pendingOrNoShowFacilityDecideStatus: true,
              neverCheckOutManagerReason: formData?.reason,
              neverCheckOutManagerReasonAttachment: res?.Key
            })
              .then(async () => {
                socket?.emit('tableJobInsert', {
                  table: 'JobPostingTable',
                  message: 'Fetch Dashboard Job'
                });
                const nurse = await getNurseUniqueIdDetails(
                  authToken,
                  job?.jobFinalSelectionNurseId
                );

                let nurseData = nurse[0];
                if (nurseData) {
                  if (nurseData.mobileId) {
                    sendNotification(authToken, {
                      expoPushToken: nurseData.mobileId,
                      title: job?.shiftTitle,
                      body:
                        `Job ${jobUniqueId(job?.id, job?.jobType)}` +
                        '-' +
                        ` Pending Clock Out Job is Approved`,
                      data: { jobId: job?.id, screen: 'JobDetailScreen' }
                    });
                  }
                  await postNurseNotification(
                    authToken,
                    nurseData?.id,
                    '',
                    jobUniqueId(job?.id, job?.jobType),
                    ` Pending Clock Out Job is Approved`,
                    'JobDetailsScreen',
                    {
                      id: job?.id
                    },
                    false,
                    false,
                    'green',
                    ''
                  );
                  socket?.emit('tableNotificationInsert', {
                    table: 'NurseNotificationTable',
                    id: nurseData?.id
                  });
                  setLoading(false);
                }

                if (
                  parseInt(job?.jobPostingTableFacilityTableId) !==
                  parseInt(job?.jobPostingTableFacilityTableId)
                ) {
                  const facilityDetail = await getFacilityDetail(
                    job?.jobPostingTableFacilityTableId
                  );

                  await postFacilityNotification(
                    authToken,
                    job?.manager?.id,
                    '',
                    jobUniqueId(job?.id, job?.jobType),
                    `Your Pending Clock Out Job Reviewed and Approved by ${facilityDetail?.firstName} ${facilityDetail?.lastName}.`,
                    'JobDetailsScreen',
                    {
                      id: job?.id
                    },
                    false,
                    false,
                    'green',
                    ''
                  );
                  socket?.emit('tableNotificationInsert', {
                    table: 'FacilityNotificationTable',
                    id: job?.manager?.id
                  });
                  if (job?.manager?.mobileId) {
                    sendNotification(authToken, {
                      expoPushToken: job?.manager?.mobileId,
                      title: jobUniqueId(job?.id, job?.jobType),
                      body: `Your Pending Clock Out Job Reviewed and Approved by ${facilityDetail?.firstName} ${facilityDetail?.lastName}.`,
                      data: { jobId: job?.id, screen: 'JobDetailScreen' }
                    });
                  }
                }
                alert('Approved successfully.');
                getJobDetail(job?.id);
              })
              .catch(e => console.log(e));
          }
        });
      }
    }
  };

  const pendingJobOrNoShowFacilityDecideCancel = async () => {
    setLoading(true);
    if (formData?.reason === '') {
      alert('Please select the reason...');
      setLoading(false);
    } else if (formData?.pendingOrNoShowFacilityDecideMessage === '') {
      alert('Please fill the message...');
      setLoading(false);
    } else {
      if (fileDoc.length === 0) {
        await updateJobTable(authToken, job?.id, {
          pendingOrNoShowFacilityDecideMessage:
            formData?.pendingOrNoShowFacilityDecideMessage,
          pendingOrNoShowFacilityDecideStatus: false,
          approved_manager: job?.jobPostingTableFacilityTableId,
          closed_by: job?.jobPostingTableFacilityTableId,
          neverCheckOutManagerReason: formData?.reason,
          neverCheckOutManagerReasonAttachment: ''
        })
          .then(async () => {
            socket?.emit('tableJobInsert', {
              table: 'JobPostingTable',
              message: 'Fetch Dashboard Job'
            });
            const nurse = await getNurseUniqueIdDetails(
              authToken,
              job?.jobFinalSelectionNurseId
            );

            let nurseData = nurse[0];

            if (nurseData) {
              if (nurseData.mobileId) {
                sendNotification(authToken, {
                  expoPushToken: nurseData.mobileId,
                  title: job?.shiftTitle,
                  body:
                    `Job ${jobUniqueId(job?.id, job?.jobType)}` +
                    '-' +
                    ` Pending Clock Out Job is Not Approved`,
                  data: { jobId: job?.id, screen: 'JobDetailScreen' }
                });
              }
              await postNurseNotification(
                authToken,
                nurseData?.id,
                '',
                jobUniqueId(job?.id, job?.jobType),
                ` Pending Clock Out Job is Not Approved`,
                'JobDetailsScreen',
                {
                  id: job?.id
                },
                false,
                false,
                'red',
                ''
              );
              socket?.emit('tableNotificationInsert', {
                table: 'NurseNotificationTable',
                id: nurseData?.id
              });
              setLoading(false);
            }

            if (
              parseInt(job?.jobPostingTableFacilityTableId) !==
              parseInt(job?.jobPostingTableFacilityTableId)
            ) {
              const facilityDetail = await getFacilityDetail(
                job?.jobPostingTableFacilityTableId
              );
              await postFacilityNotification(
                authToken,
                job?.manager?.id,
                '',
                jobUniqueId(job?.id, job?.jobType),
                `Your Pending Clock Out Job Reviewed and Not Approved by ${facilityDetail?.firstName} ${facilityDetail?.lastName}.`,
                'JobDetailsScreen',
                {
                  id: job?.id
                },
                false,
                false,
                'green',
                ''
              );
              socket?.emit('tableNotificationInsert', {
                table: 'FacilityNotificationTable',
                id: job?.manager?.id
              });
              if (job?.manager?.mobileId) {
                sendNotification(authToken, {
                  expoPushToken: job?.manager?.mobileId,
                  title: jobUniqueId(job?.id, job?.jobType),
                  body: `Your Pending Clock Out Job Reviewed and Not Approved by ${facilityDetail?.firstName} ${facilityDetail?.lastName}.`,
                  data: { jobId: job?.id, screen: 'JobDetailScreen' }
                });
              }
            }
            alert('Not-Approved successfully.');
            getJobDetail(job?.id);
          })
          .catch(e => console.log(e));
      } else {
        const buffer = await handleConvert(fileDoc);
        let name = `pendingNeverCheckOut/${`pendingNeverCheckOutManager-${jobUniqueIdDoc(
          job?.createdAt,
          job?.jobType
        )}`}.pdf`;
        await uploadFile(authToken, name, buffer, '').then(async res => {
          if (res && res?.Key) {
            await updateJobTable(authToken, job?.id, {
              pendingOrNoShowFacilityDecideMessage:
                formData?.pendingOrNoShowFacilityDecideMessage,
              pendingOrNoShowFacilityDecideStatus: false,
              approved_manager: job?.jobPostingTableFacilityTableId,
              closed_by: job?.jobPostingTableFacilityTableId,
              neverCheckOutManagerReason: formData?.reason,
              neverCheckOutManagerReasonAttachment: res?.Key
            })
              .then(async () => {
                socket?.emit('tableJobInsert', {
                  table: 'JobPostingTable',
                  message: 'Fetch Dashboard Job'
                });
                const nurse = await getNurseUniqueIdDetails(
                  authToken,
                  job?.jobFinalSelectionNurseId
                );

                let nurseData = nurse[0];

                if (nurseData) {
                  if (nurseData.mobileId) {
                    sendNotification(authToken, {
                      expoPushToken: nurseData.mobileId,
                      title: job?.shiftTitle,
                      body:
                        `Job ${jobUniqueId(job?.id, job?.jobType)}` +
                        '-' +
                        ` Pending Clock Out Job is Not Approved`,
                      data: { jobId: job?.id, screen: 'JobDetailScreen' }
                    });
                  }
                  await postNurseNotification(
                    authToken,
                    nurseData?.id,
                    '',
                    jobUniqueId(job?.id, job?.jobType),
                    ` Pending Clock Out Job is Not Approved`,
                    'JobDetailsScreen',
                    {
                      id: job?.id
                    },
                    false,
                    false,
                    'red',
                    ''
                  );
                  socket?.emit('tableNotificationInsert', {
                    table: 'NurseNotificationTable',
                    id: nurseData?.id
                  });
                  setLoading(false);
                }

                if (
                  parseInt(job?.jobPostingTableFacilityTableId) !==
                  parseInt(job?.jobPostingTableFacilityTableId)
                ) {
                  const facilityDetail = await getFacilityDetail(
                    job?.jobPostingTableFacilityTableId
                  );
                  await postFacilityNotification(
                    authToken,
                    job?.manager?.id,
                    '',
                    jobUniqueId(job?.id, job?.jobType),
                    `Your Pending Clock Out Job Reviewed and Not Approved by ${facilityDetail?.firstName} ${facilityDetail?.lastName}.`,
                    'JobDetailsScreen',
                    {
                      id: job?.id
                    },
                    false,
                    false,
                    'green',
                    ''
                  );
                  socket?.emit('tableNotificationInsert', {
                    table: 'FacilityNotificationTable',
                    id: job?.manager?.id
                  });
                  if (job?.manager?.mobileId) {
                    sendNotification(authToken, {
                      expoPushToken: job?.manager?.mobileId,
                      title: jobUniqueId(job?.id, job?.jobType),
                      body: `Your Pending Clock Out Job Reviewed and Not Approved by ${facilityDetail?.firstName} ${facilityDetail?.lastName}.`,
                      data: { jobId: job?.id, screen: 'JobDetailScreen' }
                    });
                  }
                }
                alert('Not-Approved successfully.');
                getJobDetail(job?.id);
              })
              .catch(e => console.log(e));
          }
        });
      }
    }
  };

  const completePayment = async data => {
    setLoading(true);
    const res = await updateJobTable(authToken, job?.id, {
      jobStatus: 'Completed',
      closed_by: job?.jobPostingTableFacilityTableId,
      worked_hours: timeDifferent(data?.checkInTime, data?.checkOutTime),
      total_payment:
        job?.jobType === 'Visit'
          ? data?.baseRate
          : totalAmount(data?.checkInTime, data?.checkOutTime, data?.baseRate),
      manager_review_comments: comments
    }).catch(e => console.log(e));
    socket?.emit('tableJobInsert', {
      table: 'JobPostingTable',
      message: 'Fetch Dashboard Job'
    });
    if (res.jobStatus === 'Completed') {
      const nurse = await getNurseUniqueIdDetails(
        authToken,
        job?.jobFinalSelectionNurseId
      );

      let nurseData = nurse[0];

      if (nurseData) {
        if (nurseData?.mobileId) {
          sendNotification(authToken, {
            expoPushToken: nurseData.mobileId,
            title: jobUniqueId(job?.id, job?.jobType) + ' ' + job?.shiftTitle,
            body: ` – Review Approved and Completed.`,
            data: { jobId: job?.id, screen: 'JobDetailScreen' }
          });
        }
        await postNurseNotification(
          authToken,
          nurseData?.id,
          '',
          jobUniqueId(job?.id, job?.jobType),
          'Review Approved and Completed.',
          'JobDetailsScreen',
          {
            id: job?.id
          },
          false,
          false,
          'green',
          ''
        );
        socket?.emit('tableNotificationInsert', {
          table: 'NurseNotificationTable',
          id: nurseData?.id
        });
        setLoading(false);
        setCompleteJob(false);
      }

      if (
        parseInt(job?.jobPostingTableFacilityTableId) !==
        parseInt(job?.jobPostingTableFacilityTableId)
      ) {
        const facilityDetail = await getFacilityDetail(
          job?.jobPostingTableFacilityTableId
        );

        await postFacilityNotification(
          authToken,
          job?.manager?.id,
          '',
          jobUniqueId(job?.id, job?.jobType),
          `Your job Reviewed and Approved by ${facilityDetail?.firstName} ${facilityDetail?.lastName}.`,
          'JobDetailsScreen',
          {
            id: job?.id
          },
          false,
          false,
          'green',
          ''
        );
        socket?.emit('tableNotificationInsert', {
          table: 'FacilityNotificationTable',
          id: job?.manager?.id
        });

        if (job?.manager?.mobileId) {
          if (job?.manager?.mobileId) {
            sendNotification(authToken, {
              expoPushToken: job?.manager?.mobileId,
              title: jobUniqueId(job?.id, job?.jobType),
              body: `Your job Reviewed and Approved by ${facilityDetail?.firstName} ${facilityDetail?.lastName}.`,
              data: { jobId: job?.id, screen: 'JobDetailScreen' }
            });
          }
        }
      }
      getJobDetail(job?.id);
    }
  };

  return (
    <div className="sticky-sidebar">
      <Card className="mb-3 fs-10">
        <Card.Body>
          <h6>Start</h6>
          <p className="mb-1">
            {moment(job?.startTime).format('ddd, MMM DD,YYYY, hh:mm A')}
          </p>
          <h6 className="mt-4">End</h6>
          <p className="mb-1">
            {moment(job?.endTime).format('ddd, MMM DD,YYYY, hh:mm A')}
          </p>
          <h6 className="mt-4">Duration</h6>
          <p className="fs-10 mb-0">{job?.jobDuration}</p>

          <h6 className="mt-4">Location</h6>
          {job?.unit && (
            <p className="fs-10 mb-0">
              {job?.unit} - {job?.floor}
            </p>
          )}
          <div className="mb-1">{job?.fullAddress}</div>
          <a
            href={`https://maps.google.com/?q=${job?.fullAddress}`}
            target="_blank"
            rel="noreferrer"
            className="text-primary"
          >
            View Map
          </a>
        </Card.Body>
      </Card>
      {(job?.jobStatus === 'Pending Approval' ||
        job?.jobStatus === 'Pending Clock Out' ||
        job?.jobStatus === 'Missed') && (
        <>
          {job?.jobStatus === 'Pending Approval' && (
            <Card className="mb-3 fs-10">
              <Card.Body>
                <div
                  style={{
                    marginVertical: 10,
                    marginBottom: 20,
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  <IconButton
                    variant="primary"
                    className="me-2"
                    size="sm"
                    onClick={() => {
                      setCompleteJob(true);
                    }}
                  >
                    {loading ? 'Loading...' : 'Close Job'}
                  </IconButton>
                </div>
              </Card.Body>
            </Card>
          )}
          {job?.jobStatus === 'Missed' &&
            job?.noShowReason !== '' &&
            job?.pendingOrNoShowFacilityDecideMessage === '' && (
              <Card className="mb-3 fs-10">
                <Card.Body>
                  <div
                    style={{
                      marginVertical: 10,
                      marginBottom: 20,
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                  >
                    <h6 className="mt-4">
                      Missed {job?.jobType} Reason (Employee)
                    </h6>
                    <p className="fs-10 mb-0">{job?.noShowReason}</p>
                    {job?.noShowComments && (
                      <>
                        <h6 className="mt-4">Notes (Employee)</h6>
                        <p className="fs-10 mb-0">{job?.noShowComments}</p>
                      </>
                    )}
                    {job?.noShowReasonAttachment && (
                      <>
                        <h6 className="mt-4">
                          Attachment submitted (Employee)
                        </h6>
                        <p className="fs-10 mb-0">{job?.noShowComments}</p>
                      </>
                    )}
                    <IconButton
                      variant="primary"
                      className="me-2 mt-2"
                      size="sm"
                      onClick={() => {
                        // setDocViewModel({
                        //   view: true,
                        //   name: 'No Show',
                        //   url: job?.noShowReasonAttachment
                        // });
                        window.open(job?.noShowReasonAttachment);
                      }}
                    >
                      Click to download the attachment
                    </IconButton>

                    {job?.pendingOrNoShowFacilityDecideMessage !== '' &&
                    !job?.pendingOrNoShowFacilityDecideStatus ? (
                      <>
                        <h6 className="mt-4">Reviewer Notes</h6>
                        <p className="fs-10 mb-0">
                          {job?.pendingOrNoShowFacilityDecideMessage}
                        </p>
                      </>
                    ) : (
                      <>
                        <Form>
                          <Row>
                            <Form.Group
                              as={Col}
                              md="12"
                              className="my-2"
                              controlId="JobType"
                            >
                              <Form.Label className="fs-9">
                                Approved Reason
                              </Form.Label>
                              <Select
                                className="basic-single"
                                classNamePrefix="select"
                                placeholder="Select..."
                                isClearable
                                isSearchable
                                name="color"
                                value={valueReason}
                                onChange={value => {
                                  setValueReason(value);
                                  if (value?.label !== 'Other') {
                                    setFormData({
                                      ...formData,
                                      reason: value?.label
                                    });
                                  }
                                }}
                                options={missedReason}
                                components={animatedComponents}
                                required
                              />
                            </Form.Group>
                          </Row>
                          {valueReason?.label === 'Other' && (
                            <Form.Group
                              as={Col}
                              md="12"
                              className="mb-2"
                              controlId="reason"
                            >
                              <Form.Label className="fs-9">Reason</Form.Label>
                              <Form.Control
                                type="text"
                                as="textarea"
                                name="reason"
                                placeholder={`Missed ${job?.jobType} Reason`}
                                required
                                value={formData?.reason}
                                onChange={handleChange}
                              />
                            </Form.Group>
                          )}
                          <Form.Group
                            as={Col}
                            md="12"
                            className="mb-2"
                            controlId="pendingOrNoShowFacilityDecideMessage"
                          >
                            <Form.Label className="fs-9">
                              Reviewer Notes
                            </Form.Label>
                            <Form.Control
                              type="text"
                              as="textarea"
                              name="pendingOrNoShowFacilityDecideMessage"
                              placeholder={`Message`}
                              required
                              value={
                                formData?.pendingOrNoShowFacilityDecideMessage
                              }
                              onChange={handleChange}
                            />
                          </Form.Group>

                          <UploadFile
                            file={fileDoc}
                            setFile={setFileDoc}
                            handleRemove={handleRemoveDoc}
                          />

                          <>
                            <h6 className="mt-4">Time Details & Adjustments</h6>
                            <p className="fs-10 mb-0">
                              Clock In Time -{' '}
                              {moment(job?.checkInTimeNurse).format('hh:mm a')}
                            </p>
                            <p className="fs-10 mb-0">
                              Clock Out Time -{' '}
                              {moment(job?.checkOutTimeNurse).format('hh:mm a')}
                            </p>
                          </>

                          <>
                            <>
                              {moment(new Date(job?.startTime)).format(
                                'hh:mm a'
                              ) ===
                              moment(
                                new Date(jobClockDetails?.checkInTimeNurse)
                              ).format('hh:mm a') ? (
                                <p className="fs-10 my-2 text-decoration">
                                  Start Time -{' '}
                                  {moment(
                                    new Date(job?.checkInTimeNurse)
                                  ).format('hh:mm a')}
                                </p>
                              ) : (
                                <p className="fs-10 my-2 text-decoration">
                                  Adjusted Time -{' '}
                                  {moment(
                                    new Date(jobClockDetails?.checkInTimeNurse)
                                  ).format('hh:mm a')}
                                </p>
                              )}

                              <DatePicker
                                popperPlacement="bottom-start"
                                selected={jobClockDetails?.checkInTimeNurse}
                                onChange={date =>
                                  setJobClockDetails({
                                    ...jobClockDetails,
                                    checkInTimeNurse: date
                                  })
                                }
                                className="form-control"
                                placeholderText="Select Time"
                                timeIntervals={5}
                                dateFormat="h:mm aa"
                                showTimeSelect
                                showTimeSelectOnly
                              />
                            </>

                            <>
                              {moment(new Date(job?.endTime)).format(
                                'hh:mm a'
                              ) ===
                              moment(
                                new Date(jobClockDetails?.checkOutTimeNurse)
                              ).format('hh:mm a') ? (
                                <p className="fs-10 my-2 text-decoration">
                                  End Time -{' '}
                                  {moment(
                                    new Date(job?.checkOutTimeNurse)
                                  ).format('hh:mm a')}
                                </p>
                              ) : (
                                <p className="fs-10 my-2 text-decoration">
                                  Adjusted Time -{' '}
                                  {moment(
                                    new Date(jobClockDetails?.checkOutTimeNurse)
                                  ).format('hh:mm a')}
                                </p>
                              )}

                              <DatePicker
                                popperPlacement="bottom-start"
                                selected={jobClockDetails?.checkOutTimeNurse}
                                onChange={date =>
                                  setJobClockDetails({
                                    ...jobClockDetails,
                                    checkOutTimeNurse: date
                                  })
                                }
                                className="form-control"
                                placeholderText="Select Time"
                                timeIntervals={5}
                                dateFormat="h:mm aa"
                                showTimeSelect
                                showTimeSelectOnly
                              />
                            </>
                          </>

                          <Button
                            variant="success"
                            className="px-4 mt-3"
                            onClick={() => pendingOrNoShowFacilityDecide(job)}
                          >
                            {loading ? 'Loading...' : 'Approve'}
                          </Button>

                          <Button
                            variant="danger"
                            className="px-4 mt-3 mx-3"
                            onClick={() =>
                              pendingOrNoShowFacilityDecideCancel()
                            }
                          >
                            {loading ? 'Loading...' : 'Not Approved'}
                          </Button>
                        </Form>
                      </>
                    )}
                  </div>
                </Card.Body>
              </Card>
            )}
          {job?.jobStatus === 'Pending Clock Out' &&
            job?.neverCheckOutReason !== '' &&
            job?.pendingOrNoShowFacilityDecideMessage === '' && (
              <Card className="mb-3 fs-10">
                <Card.Body>
                  <div
                    style={{
                      marginVertical: 10,
                      marginBottom: 20,
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                  >
                    <h6 className="mt-4">
                      Pending Clock Out Reason (Employee)
                    </h6>
                    <p className="fs-10 mb-0">{job?.neverCheckOutReason}</p>

                    {job?.neverCheckOutReasonAttachment && (
                      <>
                        <h6 className="mt-4">Attachment (Employee)</h6>

                        <IconButton
                          variant="primary"
                          className="me-2 mt-2"
                          size="sm"
                          onClick={() => {
                            // setDocViewModel({
                            //   view: true,
                            //   name: 'Pending Clock Out',
                            //   url: job?.neverCheckOutReasonAttachment
                            // });
                            window.open(job?.neverCheckOutReasonAttachment);
                          }}
                        >
                          Click to download the attachment
                        </IconButton>
                      </>
                    )}

                    {job?.pendingOrNoShowFacilityDecideMessage !== '' &&
                    !job?.pendingOrNoShowFacilityDecideStatus ? (
                      <>
                        <h6 className="mt-4">Reviewer Notes</h6>
                        <p className="fs-10 mb-0">
                          {job?.pendingOrNoShowFacilityDecideMessage}
                        </p>
                      </>
                    ) : (
                      <>
                        <Form>
                          <Row>
                            <Form.Group
                              as={Col}
                              md="12"
                              className="my-2"
                              controlId="JobType"
                            >
                              <Form.Label className="fs-9">
                                Approved Reason
                              </Form.Label>
                              <Select
                                className="basic-single"
                                classNamePrefix="select"
                                placeholder="Select..."
                                isClearable
                                isSearchable
                                name="color"
                                value={valueReason}
                                onChange={value => {
                                  setValueReason(value);
                                  if (value?.label !== 'Other') {
                                    setFormData({
                                      ...formData,
                                      reason: value?.label
                                    });
                                  }
                                }}
                                options={missedReason}
                                components={animatedComponents}
                                required
                              />
                            </Form.Group>
                          </Row>
                          {valueReason?.label === 'Other' && (
                            <Form.Group
                              as={Col}
                              md="12"
                              className="mb-2"
                              controlId="reason"
                            >
                              <Form.Label className="fs-9">Reason</Form.Label>
                              <Form.Control
                                type="text"
                                as="textarea"
                                name="reason"
                                placeholder={`Missed ${job?.jobType} Reason`}
                                required
                                value={formData?.reason}
                                onChange={handleChange}
                              />
                            </Form.Group>
                          )}
                          <Form.Group
                            as={Col}
                            md="12"
                            className="mb-2"
                            controlId="pendingOrNoShowFacilityDecideMessage"
                          >
                            <Form.Label className="fs-9">
                              Reviewer Notes
                            </Form.Label>
                            <Form.Control
                              type="text"
                              as="textarea"
                              name="pendingOrNoShowFacilityDecideMessage"
                              placeholder={`Message`}
                              required
                              value={
                                formData?.pendingOrNoShowFacilityDecideMessage
                              }
                              onChange={handleChange}
                            />
                          </Form.Group>

                          <UploadFile
                            file={fileDoc}
                            setFile={setFileDoc}
                            handleRemove={handleRemoveDoc}
                          />

                          {job?.timeAdjustByNurse ? (
                            <>
                              <h6 className="mt-4">
                                Requested Time Adjustment
                              </h6>
                              <p className="fs-10 mb-0">
                                Clock In Time -{' '}
                                {job?.checkInTime !== '' &&
                                  moment(new Date(job?.checkInTime)).format(
                                    'hh:mm a'
                                  )}
                              </p>
                              <p className="fs-10 mb-0">
                                Clock Out Time -{' '}
                                {job?.checkOutTimeNurse !== '' &&
                                  moment(
                                    new Date(job?.checkOutTimeNurse)
                                  ).format('hh:mm a')}
                              </p>
                            </>
                          ) : (
                            <>
                              <h6 className="mt-4">Time Details</h6>
                              <p className="fs-10 mb-0">
                                Clock In Time -{' '}
                                {moment(new Date(job?.checkInTime)).format(
                                  'hh:mm a'
                                )}
                              </p>
                              <p className="fs-10 mb-0">
                                Clock Out Time -{' '}
                                {moment(
                                  new Date(job?.checkOutTimeNurse)
                                ).format('hh:mm a')}
                              </p>
                            </>
                          )}

                          <Button
                            variant="success"
                            className="px-4 mt-3"
                            onClick={() => pendingJobOrNoShowFacilityDecide()}
                          >
                            {loading ? 'Loading...' : 'Approve'}
                          </Button>

                          <Button
                            variant="danger"
                            className="px-4 mt-3 mx-3"
                            onClick={() =>
                              pendingJobOrNoShowFacilityDecideCancel()
                            }
                          >
                            {loading ? 'Loading...' : 'Not Approved'}
                          </Button>
                        </Form>
                      </>
                    )}
                  </div>
                </Card.Body>
              </Card>
            )}
          <Modal
            show={docViewModel.view}
            onHide={() => {
              setDocViewModel({
                view: false,
                name: '',
                url: ''
              });
            }}
            contentClassName="border"
            centered
          >
            <Modal.Header
              closeButton
              closeVariant={isDark ? 'white' : undefined}
              className="bg-body-tertiary px-x1 border-bottom-0"
            >
              <Modal.Title>
                <h5 className="mb-0">{docViewModel.name}</h5>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="px-x1 pb-x1 pt-1 fs-10">
              <iframe
                title="My Website"
                src={`https://docs.google.com/gview?url=${docViewModel.url}&embedded=true`}
                style={{ width: '100%', height: '100vh', border: 'none' }}
              />
            </Modal.Body>
            <Modal.Footer className="bg-body-tertiary px-x1 border-top-0">
              <Button
                variant="secondary"
                size="sm"
                onClick={() => {
                  setDocViewModel({
                    view: false,
                    name: '',
                    url: ''
                  });
                }}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal
            show={completeJob}
            onHide={() => setCompleteJob(false)}
            contentClassName="border"
            centered
          >
            <Modal.Header
              closeButton
              closeVariant={isDark ? 'white' : undefined}
              className="bg-body-tertiary px-x1 border-bottom-0"
            >
              <Modal.Title>
                <h5 className="mb-0">Pending Approval</h5>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="px-x1 pb-x1 pt-1 fs-10">
              <Form.Group as={Col} md="12" className="mb-2" controlId="reason">
                <Form.Label className="fs-9">Comments</Form.Label>
                <Form.Control
                  type="text"
                  as="textarea"
                  name="reason"
                  placeholder={`Reason...`}
                  required
                  value={comments}
                  onChange={e => setComments(e.target.value)}
                />
              </Form.Group>
            </Modal.Body>
            <Modal.Footer className="bg-body-tertiary px-x1 border-top-0">
              <Button
                variant="secondary"
                size="sm"
                onClick={() => {
                  setCompleteJob(true);
                  setComments('');
                }}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                size="sm"
                onClick={() => {
                  !loading && completePayment(job);
                }}
              >
                {loading ? 'Loading...' : 'Approve'}
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      )}
      {/* <Events cardTitle="Events you may like" events={events.slice(2, 5)} /> */}
    </div>
  );
};

JobDetailAside.propTypes = {
  job: PropTypes.any,
  getJobDetail: PropTypes.any
};

export default JobDetailAside;
